import wishlistQuery from '../../../graphql/wishlist.graphql';
import axios from '../../utils/axios';

export const wishlist = {
    namespaced: true,

    state: () => {
        return {
            items: [],
        };
    },

    mutations: {
        toggleLocalWishlist(state, elementId) {
            if (getters.isInWishlist(state)(elementId)) {
                state.items = state.items.filter((item) => { return `${item.elementId}` === `${elementId}`; });
            } else {
                const items = [
                    ...state.items,
                    { elementId },
                ];

                state.items = items;
            }
        },

        removeLocalWishlist(state, elementId) {
            if (getters.isInWishlist(state)(elementId)) {
                state.items = state.items.filter((item) => { return `${item.elementId}` === `${elementId}`; });
            }
        },

        addLocalWishlist(state, elementId) {
            if (!getters.isInWishlist(state)(elementId)) {
                const items = [
                    ...state.items,
                    { elementId },
                ];

                state.items = items;
            }
        },

        setWishlist(state, items) {
            state.items = items.map((item) => {
                return {
                    elementId: item.elementId,
                    title: item.title,
                };
            });
        },
    },

    actions: {
        async addToWishlist({ commit, dispatch }, elementId) {
            try {
                commit('addLocalWishlist', elementId);

                await axios.post('/actions/wishlist/items/add', {
                    elementId,
                });

                await dispatch('loadWishlist');

                return true;
            } catch (error) {
                console.error(error);
            }

            return false;
        },

        async removeFromWishlist({ commit, dispatch }, elementId) {
            try {
                commit('removeLocalWishlist', elementId);

                await axios.post('/actions/wishlist/items/remove', {
                    elementId,
                });

                await dispatch('loadWishlist');

                return true;
            } catch (error) {
                console.error(error);
            }

            return false;
        },

        async toggleWishlist({ commit, dispatch }, elementId) {
            try {
                commit('toggleLocalWishlist', elementId);

                await axios.post('/actions/wishlist/items/toggle', {
                    elementId,
                });

                await dispatch('loadWishlist');

                return true;
            } catch (error) {
                console.error(error);
            }

            return false;
        },

        async loadWishlist({ commit }) {
            try {
                const sessionId = document.head.querySelector('meta[name="wishlist-session"]').content || '';

                if (sessionId) {
                    const { data: { data: { wishlistItems } } } = await axios.post('/api', {
                        query: wishlistQuery,
                        variables: {
                            sessionId,
                        },
                    });

                    if (wishlistItems.length) {
                        commit('setWishlist', wishlistItems[0].items);
                    }
                }

                return true;
            } catch (error) {
                console.error(error);
            }

            return false;
        },
    },

    getters: {
        hasItems(state) {
            return state.items.length > 0;
        },

        itemCount(state) {
            return state.items.length;
        },

        isInWishlist(state) {
            return (elementId) => { return !!state.items.find((item) => { return `${item.elementId}` === `${elementId}`; }); };
        },
    },
};
